import { FloraVersion } from '../../containers/flora/flora.type';
import type { FloraModelOption, UseAIResponse } from './agent-client.type';
import { FloraIntegrationSource } from './agent-client.type';

class UseAIResult {
  canUseAI: boolean;
  floraIntegrationStatuses?: Record<FloraIntegrationSource, boolean>;
  floraVersionsAvailable?: FloraVersion[];
  floraModelsAvailable: FloraModelOption[];
  constructor(response: UseAIResponse) {
    this.canUseAI = response.can_use_ai;
    this.floraIntegrationStatuses =
      response.flora_integration_statuses || ({} as Record<FloraIntegrationSource, boolean>);
    this.floraVersionsAvailable = response.flora_versions_available || [FloraVersion.LANGCHAIN];
    this.floraModelsAvailable = response.flora_models_available || [];
  }
}

export { UseAIResult };
